import React from 'react';
import Marquee from 'react-fast-marquee';
import { useContent } from '../../lib/content';
import { pickLocale } from '../../lib/api';

export default function Logos() {
  const { content, locale } = useContent();
  const data = content.logos || {};
  const items = (data.items || []).filter(Boolean);
  if (items.length === 0) return null;

  return (
    <section
      id="logos"
      data-testid="logos-section"
      className="py-16 md:py-24 bg-bg overflow-hidden"
    >
      <div className="text-center mb-10">
        <p className="text-eyebrow text-ink-muted">{pickLocale(data.eyebrow, locale)}</p>
      </div>

      <div className="marquee-mask">
        <Marquee gradient={false} speed={30} pauseOnHover>
          {[...items, ...items].map((logo, i) => (
            <div
              key={i}
              data-testid={`logo-item-${i % items.length}`}
              className="mx-10 md:mx-14 flex items-center justify-center text-ink-muted hover:text-ink transition-colors"
            >
              {logo.image ? (
                <img loading="lazy" decoding="async"
                  src={logo.image}
                  alt={logo.name || 'logo'}
                  className="h-10 md:h-14 max-w-[180px] object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all"/>
              ) : (
                <span className="font-display text-xl md:text-3xl tracking-wide whitespace-nowrap text-ink-muted/80">
                  {logo.name || `BRAND ${i + 1}`}
                </span>
              )}
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
